import { gsap, Power2, Back} from "gsap";
import { Point, BLEND_MODES, Texture } from "pixi.js";
import { StageLayer } from '@nolimitcity/slot-launcher/bin/StageLayer';
import { JumpingWildSymbol } from './JumpingWildSymbol';
import { SanEngineManager } from "../../engine/SanEngineManager";
import { ArrayHelper } from "../../../core/utils/ArrayHelper";
import { SanJumpData } from "../../server/base/IData";


export class JumpingWildController extends PIXI.Container implements StageLayer {

    private _items:JumpingWildSymbol[] = [];
    public _firstTimeApply:boolean = true;

    constructor(){
        super();
        SanEngineManager.callReSizeStack.push(() => this.UpdatePos());
    }

    public createRestoreJW(jwData:SanJumpData[], show:boolean = true): void {
        jwData.forEach(data => {
            const jwSym = this.addChild(new JumpingWildSymbol(this._items.length,data.to.reel,data.to.row));
            jwSym.changeMult(data.to.multiplier!)
            this._items.push(jwSym);
            jwSym.resize();
            jwSym.alpha  = show ? 1 : 0;
            if(show) jwSym.onSpinStop(0.01);
        });
    }

    public createJumpWild(): JumpingWildSymbol {
        const jwSym = this.addChild(new JumpingWildSymbol(this._items.length));
        this._items.push(jwSym);
        jwSym.resize();
        return jwSym;
    }

    public get activeJW():JumpingWildSymbol[]{
        return this._items.filter(item => item.visible);
    }
    
    public get items():JumpingWildSymbol[]{
        return this._items as JumpingWildSymbol[];
    }

    public jumpDelay(id:number):number {
        const item: JumpingWildSymbol = this.getExistingItem(id)!;
        return item.timeline ? item.timeline!.duration() - item.timeline!.time() : 0 ;
    }

    public getExistingItem(ID:number):JumpingWildSymbol{
        for(let id:number = 0; id < this._items.length; id++){
            if(this._items[id] && (this._items[id] as JumpingWildSymbol).ID == ID) return this._items[id] as JumpingWildSymbol;
        }

        this.createJumpWild().alpha = this._firstTimeApply ? 0 : 1;
        
        return ArrayHelper.fetchLastValue(this._items);
    }

    public getJWOnReel(reelID:number):JumpingWildSymbol[]{
        return this._items.filter((wItem) => { return wItem.ReelID == reelID});
    }

    public UpdatePos():void{
        this._items.forEach(item => item.resize());
    }

    public CleanAndReset():void{
        this._items.forEach(item => item.remove());
        this.removeChildren();
        this._items = [];
        this._firstTimeApply = true;
    }
}